import { FlexHorizontal, LoadMask, Spacer, useToasts } from '@vestaboard/installables'

import { Link } from '../../link'
import React from 'react'
import { TemplateCategoryForm } from '../components/TemplateCategoryForm'
import { Typography } from '@material-ui/core'
import { tryAsync } from '../../../utils/tryAsync'
import { useCreateTemplateCategory } from '../hooks/useCreateTemplateCategory'
import { useHistory } from 'react-router'

export const CreateCategory = () => {
  const history = useHistory()
  const { addToast } = useToasts()
  const [createTemplateCategory, { loading: saving }] = useCreateTemplateCategory()

  return (
    <>
      <FlexHorizontal>
        <Link to='/message-templates/categories'>
          <Typography variant='h4'>Template Categories</Typography>
        </Link>
        <Typography variant='h4'> / Create</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      <TemplateCategoryForm
        onCreate={async templateCategory => {
          const { result } = await tryAsync(() =>
            createTemplateCategory({
              variables: {
                input: {
                  title: templateCategory.title
                }
              }
            })
          )

          if (result && result.data?.createTemplateCategory.__typename === 'TemplateCategoryV2') {
            history.push(`/message-templates/category/${result.data?.createTemplateCategory.id}`)
          } else {
            console.warn(result)
            addToast('There was an error saving your template category', {
              appearance: 'error'
            })
          }
        }}
      />
      {saving ? <LoadMask /> : null}
    </>
  )
}
